module.exports = __webpack_public_path__ + "img/平乡自行车.40ed92e6.jpg";